import { render } from "./input-multi-range.vue?vue&type=template&id=1c72e97d"
import script from "./input-multi-range.vue?vue&type=script&lang=js"
export * from "./input-multi-range.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/maskingruppen-new/maskingruppen-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__